// @generated by protobuf-ts 2.11.1 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/enums/listing/filter/dropdown_group_name.proto" (package "bianka.enums.listing.filter", syntax proto3)
// tslint:disable
/**
 * @generated from protobuf enum bianka.enums.listing.filter.DropdownGroupName
 */
export enum DropdownGroupName {
    /**
     * @generated from protobuf enum value: DROPDOWN_GROUP_NAME_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: DROPDOWN_GROUP_NAME_SELLER_DETAILS = 1;
     */
    SELLER_DETAILS = 1,
    /**
     * @generated from protobuf enum value: DROPDOWN_GROUP_NAME_DELIVERY_TIME = 2;
     */
    DELIVERY_TIME = 2,
    /**
     * @generated from protobuf enum value: DROPDOWN_GROUP_NAME_BUDGET = 3;
     */
    BUDGET = 3,
    /**
     * @generated from protobuf enum value: DROPDOWN_GROUP_NAME_CATEGORY = 4;
     */
    CATEGORY = 4,
    /**
     * @generated from protobuf enum value: DROPDOWN_GROUP_NAME_TOGGLES = 5;
     */
    TOGGLES = 5,
    /**
     * @generated from protobuf enum value: DROPDOWN_GROUP_NAME_VISUAL_FILTERS = 6;
     */
    VISUAL_FILTERS = 6,
    /**
     * @generated from protobuf enum value: DROPDOWN_GROUP_NAME_SERVICE_OPTIONS = 7;
     */
    SERVICE_OPTIONS = 7,
    /**
     * @generated from protobuf enum value: DROPDOWN_GROUP_NAME_SORT_BY = 8;
     */
    SORT_BY = 8
}
